import React from "react";
import withStyles from "react-jss";
import classNames from "classnames";

const styles = (theme) => {
	return {
		radioItem: {
			display: "flex",
			alignItems: "center",
			marginBottom: "20px",
			"&:last-child": {
				marginBottom: 0,
			},
		},
		radioItemWrapper: {
			display: "inline-flex",
			alignItems: "center",
			cursor: "pointer",
		},
		radioItemCircle: {
			width: "30px",
			height: "30px",
			borderRadius: "50%",
			border: `solid 2px ${theme.palette.colors.cloudyBlue}`,
			marginRight: "14px",
			flexShrink: 0,
		},
		radioItemText: {
			fontFamily: theme.fonts.medium,
			fontSize: "18px",
			color: theme.palette.colors.oneMoreGrey,
		},
		radioItemActive: {
			"& $radioItemCircle": {
				border: `solid 8px ${theme.palette.colors.purplishBlue}`,
			},
			"& $radioItemText": {
				color: theme.palette.colors.purplishBlue,
			},
		},
		[`@media (max-width: ${theme.media.sm})`]: {
			radioItemCircle: {
				width: "20px",
				height: "20px",
				borderRadius: "50%",
				border: `solid 2px ${theme.palette.colors.cloudyBlue}`,
				marginRight: "14px",
			},
			radioItemText: {
				fontSize: "16px",
			},
			radioItemActive: {
				"& $radioItemCircle": {
					border: `solid 5px ${theme.palette.colors.purplishBlue}`,
				},
			},
		},
	};
};

class RadioButton extends React.Component {
	render() {
		let classes = this.props.classes;
		return (
			<div
				datatest={this.props.datatest}
				className={classNames(classes.radioItem, {
					[classes.radioItemActive]: this.props.checked,
				})}
			>
				<div className={classes.radioItemWrapper} onClick={this.props.onClickHandler}>
					<div className={classes.radioItemCircle} />
					<div className={classes.radioItemText}>{this.props.name}</div>
				</div>
			</div>
		);
	}
}

export default withStyles(styles)(RadioButton);
